import { render, staticRenderFns } from "./BiayaJasa.vue?vue&type=template&id=4f6fe1ef&scoped=true"
import script from "./BiayaJasa.vue?vue&type=script&lang=js"
export * from "./BiayaJasa.vue?vue&type=script&lang=js"
import style0 from "./BiayaJasa.vue?vue&type=style&index=0&id=4f6fe1ef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f6fe1ef",
  null
  
)

export default component.exports